export default __webpack_public_path__ + "static/media/realTime.489058cc.png";